const firebaseConfig = {
  apiKey: "AIzaSyCEei0lCfwoV0r0nlXT-JjRcXQ8_Er3lXo",
  authDomain: "traveledor-authentication.firebaseapp.com",
  projectId: "traveledor-authentication",
  storageBucket: "traveledor-authentication.appspot.com",
  messagingSenderId: "487582536000",
  appId: "1:487582536000:web:f9a9ce6c7653a773daeaa5",
  measurementId: "G-TT61Z1645H"
};

export default firebaseConfig;